var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { Step } from '@/models/Step';
import { sanitizeString } from '@/support/String';
let StepsCreator = class StepsCreator extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.newStep = new Step({ text: '' });
        this.originalValue = '';
        this.isStoring = false;
        this.isUploading = false;
        this.fileName = '';
        this.isShowingDialog = false;
        this.isLoading = true;
        this.selectedStep = null;
        this.fileInput = null;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    remove(step) {
        this.$emit('onDelete', step);
    }
    clear() {
        this.newStep = new Step();
        this.fileName = '';
    }
    store() {
        if (!this.newStep.text) {
            return;
        }
        this.$emit('onSave', this.newStep);
    }
    update(step) {
        this.$emit('onUpdate', step);
    }
    inputChanged(event) {
        this.fileInput = event.target;
        const files = this.fileInput.files;
        if (files === null || !files.length) {
            return;
        }
        this.newStep.file = files[0];
        this.fileName = files[0].name;
    }
    findById(id) {
        return this.steps.findIndex((step) => step.id === id);
    }
    sanitizeString(value) {
        return sanitizeString(value);
    }
    // #endregion
    // #region Async methods
    // #endregion
    // #region Getters & Setters
    get editorOptions() {
        return {
            placeholder: this.$t('steps.placeholder'),
            modules: {
                toolbar: true,
                magicUrl: true,
            },
        };
    }
};
__decorate([
    Prop({ default: [] }),
    __metadata("design:type", Array)
], StepsCreator.prototype, "steps", void 0);
StepsCreator = __decorate([
    Component({
        components: {
            quillEditor,
        },
    })
], StepsCreator);
export default StepsCreator;
